"use client";

import React from "react";
import { Microscope, Target, Wrench } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  title: "NEURO-SENSORY",
  description: "Optimize the brain-body connection through targeted visual and vestibular training to sharpen reaction times and spatial awareness.",
  icon: Microscope
}, {
  title: "MOVEMENT ASSESSMENT",
  description: "Identify biomechanical inefficiencies with clinical precision to eliminate pain triggers and unlock hidden athletic potential.",
  icon: Target
}, {
  title: "ELITE PERFORMANCE",
  description: "One-on-one treatment protocols designed for high-level athletes who demand rapid recovery and superior physical output.",
  icon: Wrench
}];
export default function TheNeuroEdge() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224645" id="the-neuro-edge" className="dark bg-background text-foreground py-24 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/5 rounded-lg blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-[30rem] h-[30rem] bg-primary/5 rounded-lg blur-[150px] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-16 md:mb-24">
          <h2 className="font-default text-4xl md:text-5xl font-bold tracking-widest mb-6 text-foreground uppercase">
            The Neuro Edge
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-default italic">
            High-performance neuro-sensory training designed to bridge the gap between clinical science and athletic dominance.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {pillars.map((pillar, index) => {
          const Icon = pillar.icon;
          return <div key={index} data-index={index} className={`transition-all duration-700 ease-out fill-mode-forwards ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${index * 150}ms`
          }}>
                <Card className="group h-full bg-card/20 backdrop-blur-sm border-border/40 hover:border-primary/60 transition-all duration-500 hover:-translate-y-3 hover:shadow-xl hover:shadow-primary/5 overflow-hidden relative rounded-md">
                  {}
                  <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-primary to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                  <CardHeader className="pt-8 pb-4">
                    <div className="mb-6 relative inline-flex">
                      {}
                      <div className="absolute inset-0 bg-primary/10 blur-lg rounded-md scale-150 group-hover:scale-110 group-hover:bg-primary/20 transition-all duration-500" />
                      
                      <div className="relative z-10 p-4 rounded-md bg-background/80 border border-border/50 group-hover:border-primary/40 transition-colors duration-500">
                        <Icon className="w-8 h-8 text-primary" strokeWidth={1.5} />
                      </div>
                    </div>
                    <CardTitle className="font-default text-xl font-bold tracking-wider text-foreground group-hover:text-primary transition-colors duration-300 uppercase">
                      {pillar.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base text-muted-foreground font-default leading-relaxed">
                      {pillar.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}